import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { IRootState } from '../../types/store';
import { findActiveMenuItem } from '../../helpers';
import { JSX, useMemo } from 'react';
import { CategoryDatagrid } from '../../components/DataGrid/Inventory/CategoryDatagrid';
import { ProductDatagrid } from '../../components/DataGrid/Inventory/ProductDatagrid';
import { ProductSyncPage } from './ProductSync';

export const InventoryPage = () => {
  const location = useLocation();
  const menuItems = useSelector((state: IRootState) => state.user.menuItems);
  const activeSubMenu = useMemo(
    () => findActiveMenuItem(menuItems, location.pathname),
    [menuItems, location.pathname],
  );

  const RenderedDatagrid: Record<string, JSX.Element> = {
    Categories: <CategoryDatagrid />,
    Products: <ProductDatagrid />,
    'Product Sync': <ProductSyncPage />,
  };

  return <>{activeSubMenu?.title && RenderedDatagrid[activeSubMenu.title]}</>;
};
